// extracted by mini-css-extract-plugin
export var currencyInput = "_iw-1";
export var currencySymbol = "_iw-0";